import {createContext, useCallback, useContext} from 'react'

export type ModalStore = {
  [key: string]: string | undefined
}

export const modalContext = createContext({
  modalStore: {} as ModalStore,
  setModalStore: (_: ModalStore) => {}
})

export function useIsModalShown() {
  const {modalStore} = useContext(modalContext)
  for (const key in modalStore) {
    if (modalStore[key] !== undefined) {
      return true
    }
  }
  return false
}

export function useModalState() {
  const {modalStore, setModalStore} = useContext(modalContext)

  const setStateForModalKey = useCallback(
    (key: string, value: string | undefined) => {
      setModalStore({...modalStore, [key]: value})
    },
    [modalStore, setModalStore]
  )

  return {modalStore, setStateForModalKey}
}
